export const formatBytes = (bytes, separator = " ") => {
    const sizes = ["B", "KB", "MB", "GB", "TB"];
    if (!bytes) return "0 B";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    if (i === 0) return `${bytes}${separator}${sizes[i]}`;
    return `${(bytes / (1024 ** i)).toFixed(1)}${separator}${sizes[i]}`;
};
